'use client';

import { c as _c } from "react/compiler-runtime";
import { useCouponSettings } from '@svs/nova-poolbetting/core/frameworks/nextjs/coupon';
import { useDraw } from '@svs/nova-poolbetting/core/frameworks/nextjs/draw';
import type { DrawNumber } from '@svs/nova-poolbetting/schema/draw';
import type { Definition } from '@svs/nova-poolbetting/schema/frameworks';
import type { SettingsKeys } from '@svs/nova-poolbetting/schema/sessionstore';
import type { EventNumber } from '@svs/nova-poolbetting/schema/sport';
import type { ReactNode } from 'react';
import { getMatchStartTime } from './getMatchStartTime';
import { Tipsinfo } from './Tipsinfo';
type TipsinfoContainerProps = {
  product: Definition['moduleEngine'];
  settingsKey: SettingsKeys;
  drawNumber: DrawNumber;
  eventNumber: EventNumber;
  className?: string;
};

/**
 * Tipsinfo container component.
 *
 * @param root0 props
 * @param root0.settingsKey settings key to get tipsinfo for eg. My bets or Play
 * @param root0.product product to get tipsinfo for
 * @param root0.drawNumber draw number for draw analysis
 * @param root0.eventNumber event number for event analysis
 * @param root0.className optional class name for styling
 * @returns tipsinfo presentational component
 */
export function TipsinfoContainer(t0) {
  const $ = _c(13);
  const {
    product,
    settingsKey,
    drawNumber,
    eventNumber,
    className
  } = t0;
  let t1;
  if ($[0] !== drawNumber || $[1] !== product) {
    t1 = {
      product,
      drawNumber
    };
    $[0] = drawNumber;
    $[1] = product;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const draw = useDraw(t1);
  const couponSettings = useCouponSettings(product, settingsKey);
  if (draw.isError || couponSettings.isError) {
    return;
  }
  const hasInfoToDisplay = couponSettings.data.tipsinfo.length > 0 || couponSettings.data.gameAnalysis.includes("Tip");
  if (!hasInfoToDisplay) {
    return;
  }
  let t2;
  if ($[3] !== draw.data || $[4] !== eventNumber) {
    t2 = getMatchStartTime(draw.data, eventNumber);
    $[3] = draw.data;
    $[4] = eventNumber;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const matchStartTime = t2;
  let t3;
  if ($[6] !== className || $[7] !== couponSettings.data || $[8] !== drawNumber || $[9] !== eventNumber || $[10] !== matchStartTime || $[11] !== product) {
    t3 = <Tipsinfo settings={couponSettings.data} matchStartTime={matchStartTime} drawNumber={drawNumber} eventNumber={eventNumber} product={product} className={className} />;
    $[6] = className;
    $[7] = couponSettings.data;
    $[8] = drawNumber;
    $[9] = eventNumber;
    $[10] = matchStartTime;
    $[11] = product;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}